module.exports = __webpack_public_path__ + "img/4.a6812133.jpg";